<template>
  <div :class="['myHandsel', { inApp: $root.$data.isApp||this.$root.miniprogram }]">
    <common-title titleName="我的定金" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="handsel-list">
      <HandselCard
        v-for="(item, index) in handselList"
        :handselInfo="item"
        :key="index"
        @updateInfo="updateInfo"
      >
        <TimerCount :handselInfo="item" @updateInfo="updateInfo" />
      </HandselCard>
    </div>
    <EmptyData v-if="!handselList.length" :emptyName="'noHandsel'" />
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import moment from 'moment';
import wx from 'weixin-js-sdk';
import { reqDepositList, reqCancelDeposit } from '@/api/personal/handsel';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import HandselCard from './components/handselCard.vue';
import TimerCount from './components/timerCount.vue';

export default {
  components: {
    CommonTitle,
    HandselCard,
    TimerCount,
    EmptyData,
  },
  data() {
    return {
      handselList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getHandselList() {
      const currentTime = await this.$root.getServerTime();
      const { code, data } = await reqDepositList();
      this.handselList = [];
      if (code === 0 && data?.length) {
        this.handselList = data;
      }
      this.handselList.forEach((item) => {
        const { status, depositOverTime, balanceOverTime } = item;
        if (status === 1) {
          const time = moment(depositOverTime).valueOf();
          Object.assign(item, { _endTime: time });
        } else if (status === 4) {
          //
          Object.assign(item, { _endTime: moment(balanceOverTime).valueOf() });
        }
        Object.assign(item, { currentTime: moment(currentTime).valueOf() });
      });
    },
    updateInfo(data) {
      const { status, handselInfo } = data;
      switch (status) {
        case 1:
          this.getHandselList();
          break;
        case 2:
          this.cancelOrder(handselInfo);
          break;
        case 3:
          this.toPay(handselInfo);
          break;
        default:
          break;
      }
    },
    // 取消定金
    async cancelOrder(handselInfo) {
      this.$dialog
        .confirm({
          // title: '提示',
          message: '确认取消定金单吗？',
          confirmButtonText: '确定',
        })
        .then(async () => {
          const { depositOrderNo } = handselInfo;
          const res = await reqCancelDeposit(depositOrderNo);
          const { code, msg } = res;
          if (code === 0) {
            this.$toast('取消成功');
            this.getHandselList();
          } else {
            this.$toast(msg);
          }
        })
        .catch(() => {});
    },
    // 下单
    toPay(handselInfo) {
      const { depositOrderNo, status } = handselInfo;
      if (this.$root.$data.isApp) {
        const param = {
          orderNo: depositOrderNo,
          type: status === 1 ? 3 : 4,
        };
        this.$sendToApp('payCenter', param, false);
      } else {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({
            url: `/myCourse/cashier/cashier?orderNo=${depositOrderNo}&source=${
              status === 1 ? 3 : 4
            }`,
          });
          return;
        }
        this.$router.push({
          path: '/cashier',
          query: {
            orderNo: depositOrderNo,
            source: status === 1 ? 3 : 4,
          },
        });
      }
    },
  },
  async created() {
    // await this.$root.currentTimeUpdate();
    this.getHandselList();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.myHandsel {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  background: #f9f9f9;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
